import { COMPONENTS } from '../../../components/components.registry';
import { NoResultsConfig } from '../../../models';

export const DEFAULT_NO_RESULTS_CONFIG: NoResultsConfig = {
  components: {
    noResults: COMPONENTS.PURE.DefaultNoResults
  }
};
